export const selectTemplateEndedStatus = (state) => state.ended;
export const selectTemplates = (state) => state.templates;
export const selectTemplatesTotal = (state) => state.total;
export const selectTemplate = (state) => state.template;
export const selectSystemTemplateTypes = (state) => state.systemTemplateTypes;
export const selectCustomTemplatesResource = (state) => state.customTemplatesResource;
